module.exports = __webpack_public_path__ + "img/decor5.0a42cb53.png";